import RichHtml from "./RichHtml"

export default RichHtml